module.exports = __webpack_public_path__ + "img/ogp_pocketorbit_big.3c5f3ad4.jpg";